import { AxiosResponse } from 'axios';

import { Contact } from '@/types/contact';
import { Organization } from '@/types/organization';
import { api } from '@/services/api/axios/instance';

type GetListParams = {
  data: {
    organizationId: Organization['id'];
  };
};

type GetParams = {
  data: {
    contactId: Contact['id'];
    organizationId: Organization['id'];
  };
};

type CreateParams = {
  data: {
    contact: Contact;
    organizationId: Organization['id'];
  };
};

type UpdateParams = {
  data: {
    contact: Contact;
    organizationId: Organization['id'];
  };
};

type DeleteParams = {
  data: {
    contactId: Contact['id'];
    organizationId: Organization['id'];
  };
};

export const contactsApi = {
  getList: async (config: GetListParams): Promise<Contact[]> => {
    const { organizationId } = config.data;
    const path = `/organizations/${organizationId}/contacts`;

    const response: AxiosResponse<{
      contacts: Contact[];
    }> = await api.get(path, config);

    return response.data.contacts;
  },
  get: async (config: GetParams): Promise<Contact> => {
    const { organizationId, contactId } = config.data;
    const path = `/organizations/${organizationId}/contacts/${contactId}`;

    const response: AxiosResponse<{
      contact: Contact;
    }> = await api.get(path, config);

    return response.data.contact;
  },
  create: async (config: CreateParams): Promise<Contact> => {
    const { organizationId, contact } = config.data;
    const path = `/organizations/${organizationId}/contacts`;

    const { id: _id, organizationId: _orgId, ...params } = contact;

    const response: AxiosResponse<{
      contact: Contact;
    }> = await api.post(path, params);

    return response.data.contact;
  },
  update: async (config: UpdateParams): Promise<Contact> => {
    const { organizationId, contact } = config.data;
    const path = `/organizations/${organizationId}/contacts/${contact.id}`;

    const { id: _id, organizationId: _orgId, ...params } = contact;

    const response: AxiosResponse<{
      contact: Contact;
    }> = await api.patch(path, params);

    return response.data.contact;
  },
  delete: async (config: DeleteParams): Promise<void> => {
    const { organizationId, contactId } = config.data;
    const path = `/organizations/${organizationId}/contacts/${contactId}`;

    await api.delete(path, config);
  },
};
